/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Settings_Home_Faq_1Inputs */

const en_settings_home_faq_1 = /** @type {(inputs: Settings_Home_Faq_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The ${i?.companyName} team is happy to make any profile changes on your
            behalf. Contact us at `)
};

/**
* | output |
* | --- |
* | "The {companyName} team is happy to make any profile changes on your behalf. Contact us at" |
*
* @param {Settings_Home_Faq_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_home_faq_1 = /** @type {((inputs: Settings_Home_Faq_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Home_Faq_1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_home_faq_1(inputs)
});